export default __webpack_public_path__ + "static/media/de_ad_banner_mobile.b70adaf7.png";